<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Editar Proveedor
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
            Datos personales
          </a>
        </li>
      <!--  <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(2)" v-bind:class="{'text-amber-600 bg-white': openTab !== 2, 'text-black bg-amber-600': openTab === 2}">
            Signos Vitales
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(3)" v-bind:class="{'text-amber-600 bg-white': openTab !== 3, 'text-black bg-amber-600': openTab === 3}">
            Contactos de Emergencia
          </a>
        </li>-->
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="update">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <select-input v-model="form.type_identity" :req="form.type_identity" :error="form.errors.type_identity" class="pr-6 pb-8 w-full lg:w-1/6" label="Tipo de Identificación" required>
                <option>Cédula</option>
                <option>Pasaporte</option>
                <option>RUC</option>
              </select-input>
          <text-input v-model="form.nid" :error="form.errors.nid" :req="form.nid" class="pb-8 pr-6 w-full lg:w-1/6" label="Identificación" required/>
                 
          <text-input v-model="form.first_name" :error="form.errors.first_name" :req="form.first_name" class="pb-8 pr-6 w-full lg:w-2/6" label="Nombres" required/>
          <text-input v-model="form.last_name" :error="form.errors.last_name" :req="form.last_name" class="pb-8 pr-6 w-full lg:w-2/6" label="Apellidos" required/>
          <text-input v-model="form.email" :error="form.errors.email" :req="form.email" class="pb-8 pr-6 w-full lg:w-2/6" label="Email" required/>
          <text-input v-model="form.phone" :error="form.errors.phone" :req="form.phone" class="pb-8 pr-6 w-full lg:w-2/6" label="Teléfono" required/>
          <text-input v-model="form.address" :error="form.errors.address" :req="form.address" class="pb-8 pr-6 w-full lg:w-2/6" label="Dirección" required/>
          </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Actualizar</loading-button>
        </div>
      </form>
            </div>
      <!--     <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
              <p>
                Completely synergize resource taxing relationships via
                premier niche markets. Professionally cultivate one-to-one
                customer service with robust ideas.
                <br />
                <br />
                Dynamically innovate resource-leveling customer service for
                state of the art customer service.
              </p>
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
              <p>
                Efficiently unleash cross-media information without
                cross-media value. Quickly maximize timely deliverables for
                real-time schemas.
                <br />
                <br />
                Dramatically maintain clicks-and-mortar solutions
                without functional solutions.
              </p>
            </div>--> 
          </div>
        </div>
       
      </div>
    </div>
  </div>
   <!-- <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">  </div>-->
  </div>
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';



export default {
  metaInfo() {
    return {
      title: `${this.form.last_name} ${this.form.first_name}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    vSelect,
    DatePicker,
  },
  layout: Layout,
  props: {
    contact: Object,
  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      profesiones: this.profesiones,
      form: this.$inertia.form({
        _method: 'put',
        type_identity: this.contact.type_identity,
        phone: this.contact.phone,
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        address: this.contact.address,
        nid: this.contact.nid,
        email: this.contact.email,
      }),
    }
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    update() {
      this.form.post(this.route('contacts.update', this.contact.id), {
      })
    },
    destroy() {
      if (confirm('Está seguro de Eliminar este Proveedor?')) {
        this.$inertia.delete(this.route('contacts.destroy', this.contact.id))
      }
    },
    restore() {
      if (confirm('Está seguro de Restaurar este Proveedor?')) {
        this.$inertia.put(this.route('contacts.restore', this.contact.id))
      }
    },
  },
}
</script>